import { Badge } from '@optools/components/ui/badge';
import { EsniRuleStatus } from '@optools/services/operator-gateway/types/generated/graphql';
import { ReactNode } from '@tanstack/react-router';
import { startCase } from 'es-toolkit';
import { CircleDashed, CircleDot, FlaskConical } from 'lucide-react';
import { ComponentProps } from 'react';

const STATUS_BADGE_VARIANTS: Record<
  EsniRuleStatus,
  { icon: ReactNode; variant: ComponentProps<typeof Badge>['variant'] }
> = {
  [EsniRuleStatus.ACTIVE]: {
    icon: <CircleDot />,
    variant: 'success',
  },
  [EsniRuleStatus.INACTIVE]: {
    icon: <CircleDashed />,
    variant: 'outline',
  },
  [EsniRuleStatus.TESTING]: {
    icon: <FlaskConical />,
    variant: 'secondary',
  },
};

export interface ESNIRuleStatusBadgeProps {
  status: EsniRuleStatus;
}

export function ESNIRuleStatusBadge({ status }: ESNIRuleStatusBadgeProps) {
  const { icon, variant } = STATUS_BADGE_VARIANTS[status];
  return (
    <Badge variant={variant}>
      {icon}
      {startCase(status)}
    </Badge>
  );
}
